<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addExplanation()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <pixl-consumer-cb (onStateChange)="setConsumerFilter($event)" />
                    </div>

                    <div class="filter-item">
                        <div class="filter-item">
                            <pixl-competency-cb (onStateChange)="setCompetencyFilter($event)" />
                        </div>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb (onStateChange)="setStateFilter($event)" />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="edit-actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editExplanation(explanation)"
                        matTooltip="{{ 'edit_meta_data_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-warning]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editContentExplanation(explanation)"
                        matTooltip="{{ 'edit_content_hint' | transloco }}"
                    >
                        <mat-icon>draw</mat-icon>
                    </button>
                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="copyExplanation(explanation)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                        (click)="confirmDelete(explanation)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button
                        [class.btn-primary]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'player_preview' | transloco }}"
                        (click)="previewPlayer2(explanation)"
                    >
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation.id }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation.name }}</td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "application" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation?.getConsumer()?.name || "---" }}</td>
            </ng-container>

            <ng-container matColumnDef="competency">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "subject" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation?.getCompetency()?.name || "---" }}</td>
            </ng-container>

            <ng-container matColumnDef="pages">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "pages" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ getPages(explanation.pages) }}</td>
            </ng-container>

            <ng-container matColumnDef="updated">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ getCreatedDate(explanation.id) | date }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "state" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >
                    <div
                        class="editstate"
                        #editStateDiv
                    >
                        <button
                            class="badge"
                            [ngClass]="getStateColor(explanation.approval)"
                            (click)="changeExplanationState(explanation)"
                        >
                            {{ getStateText(explanation.approval) }}
                        </button>
                        <!--
            <mat-list class="dropdown-menu" aria-labelledby="dropdownMenu">
              <mat-list-item role="listitem">Item 1</mat-list-item>
              <mat-list-item role="listitem">Item 2</mat-list-item>
            </mat-list>
            -->
                    </div>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (dblclick)="editContentExplanation(row)"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>

        <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
    </div>
</div>